// See Venus OwnCurrentHome
export enum OwnCurrentHome {
    OwnAHomeWithMortgage = 1,
    OwnAHomeWithoutMortgage = 2,
    TenantWithMortgage = 3,
    TenantWithoutMortgage = 4
}
